import { useEffect } from 'react'
import { useMap } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet.markercluster'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import { formatArea, formatRelative, freshnessOf } from '../utils/events'

// Échelle racine carrée : une surface 100× plus grande donne un point 10× plus large,
// sinon les mégafeux écrasent visuellement tout le reste.
const radiusFor = hectares => {
    if (hectares == null) return 6
    return Math.max(5, Math.min(22, 4 + Math.sqrt(hectares) / 6))
}

const iconFor = event => {
    const size = radiusFor(event.hectares) * 2
    return L.divIcon({
        className: 'fire-marker-wrapper',
        html: `<span class="fire-marker freshness--${freshnessOf(event.timestamp)}" style="width:${size}px;height:${size}px"></span>`,
        iconSize: [size, size],
        iconAnchor: [size / 2, size / 2],
    })
}

const clusterIcon = cluster => {
    const count = cluster.getChildCount()
    const tier = count < 10 ? 'sm' : count < 50 ? 'md' : 'lg'
    return L.divIcon({
        className: 'cluster-wrapper',
        html: `<span class="cluster cluster--${tier}">${count}</span>`,
        iconSize: L.point(40, 40),
    })
}

const MarkerCluster = ({ events, onSelect }) => {
    const map = useMap()

    useEffect(() => {
        const group = L.markerClusterGroup({
            chunkedLoading: true,
            maxClusterRadius: 48,
            showCoverageOnHover: false,
            iconCreateFunction: clusterIcon,
        })

        for (const event of events) {
            const marker = L.marker([event.lat, event.lng], {
                icon: iconFor(event),
                title: event.title,
            })
            marker.bindTooltip(
                `<strong>${event.title}</strong><br>${formatArea(event.hectares)} · ${formatRelative(event.timestamp)}`,
                { direction: 'top', offset: [0, -6] },
            )
            marker.on('click', () => onSelect(event.id))
            group.addLayer(marker)
        }

        map.addLayer(group)
        return () => { map.removeLayer(group) }
    }, [map, events, onSelect])

    return null
}

export default MarkerCluster
